// https://colornamer.netlify.com
export const colors = {
  white: '#ffffff',
  mirage: '#17242a',
  oxfordBlue: '#334a54',
  blackHaze: '#e7e9e9',
  robinsEggBlue: '#00bab5',
  iron: '#cdcfd0',
};

export const devices = {
  tablet: (css: string | TemplateStringsArray) =>
    `@media (min-width: 768px) {${css}}`,
  desktop: (css: string | TemplateStringsArray) =>
    `@media (min-width: 1440px) {${css}}`,
};

export const theme = {
  colors,
  devices,
};

export type Theme = typeof theme;

declare module 'styled-components' {
  // At this point, we are overwriting the styled-components interface with extended 'DefaultTheme' using our theme type
  export interface DefaultTheme extends Theme {}
}
